<div class="dl-chat__bel"
     [class.dl-chat__bel--bericht]="heeftNieuw()"
     [class.dl-chat__bel--open]="_open()">
    <span class="fa-solid fa-comment-dots"(click)="klikBel()"></span>
</div>
@if (_open()) {
    <div class="dl-chat__box">
        <div class="dl-chat__log" #chatlog>
            @for (regel of regelsWeergave(); track regel.id) {
                <div>
                    <div class="dl-chat__header">
                        <span class="dl-chat__user">{{regel.user}}</span>
                        <span class="dl-chat__moment">{{regel.tijd}}</span>
                    </div>
                    <div class="dl-chat__tekst">{{regel.tekst}}</div>
                </div>
            }
        </div>
        @if (magVersturen()) {
            <div class="dl-chat__invoer">
                <textarea class="dl-chat__regel"
                          aria-label="chatregel"
                          rows="2"
                          [placeholder]="'CHAT.TIK' | translate"
                          [value]="_tekst"
                          (input)="onInvoer($event)"
                          (keydown)="onToets($event)"></textarea>
                <div class="dl-chat__verstuur" [title]="'CHAT.SEND' | translate" (click)="verstuurTekst()">
                    <span class="fa-solid fa-paper-plane"></span>
                </div>
            </div>
        }
    </div>
}
